/* ==========================================================================
   AURA — TABS
   Lightweight tab controller for [data-aura-tabs] (product details).
   Delegated clicks + arrow-key navigation; ARIA kept in sync.
   ========================================================================== */
(function () {
  'use strict';

  function activate(root, tabId) {
    root.querySelectorAll('.aura-tabs__tab').forEach((tab) => {
      const on = tab.dataset.tab === tabId;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
    });
    root.querySelectorAll('.aura-tabs__panel').forEach((panel) => {
      const on = panel.dataset.panel === tabId;
      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
    });
  }

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.aura-tabs__tab');
    if (!tab) return;
    const root = tab.closest('[data-aura-tabs]');
    if (root) activate(root, tab.dataset.tab);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    const current = e.target.closest('.aura-tabs__tab');
    if (!current) return;
    const root = current.closest('[data-aura-tabs]');
    if (!root) return;

    const tabs = Array.prototype.slice.call(root.querySelectorAll('.aura-tabs__tab'));
    const i = tabs.indexOf(current);
    const next = e.key === 'ArrowRight' ? tabs[i + 1] || tabs[0] : tabs[i - 1] || tabs[tabs.length - 1];
    if (next) {
      activate(root, next.dataset.tab);
      next.focus();
    }
  });
})();
